export const validImageMimeTypes = 'image/png,image/x-png,image/gif,image/jpeg'
